import { render } from "./business-settings.vue?vue&type=template&id=7152ccc4&scoped=true"
import script from "./business-settings.vue?vue&type=script&lang=js"
export * from "./business-settings.vue?vue&type=script&lang=js"

import "./business-settings.vue?vue&type=style&index=0&id=7152ccc4&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7152ccc4"]])

export default __exports__